// extracted by mini-css-extract-plugin
module.exports = {"items":"items__uzOrN8hfDY+of","item":"item__PAP5pW5TNYI6J","iconWrap":"iconWrap__qh96xgViZls-D","itemText":"itemText__1A5MYq8XfMrk7","icon":"icon__z9oN-NuXI6uSa"};